/// <reference path="../../typings/jquery/jquery.d.ts" />
/// <reference path="../../typings/jquery/jquery.extensions.d.ts" />
/// <reference path="../../common/interfaces.ts" />
var TotalJobsGroup;
(function (TotalJobsGroup) {
    var Header;
    (function (Header) {
        (function (LoggedInState) {
            LoggedInState[LoggedInState["NotLoggedIn"] = 0] = "NotLoggedIn";
            LoggedInState[LoggedInState["SoftLogin"] = 1] = "SoftLogin";
            LoggedInState[LoggedInState["HardLogin"] = 2] = "HardLogin";
        })(Header.LoggedInState || (Header.LoggedInState = {}));
        var LoggedInState = Header.LoggedInState;
        // This class is used by SavedJobs. You must test SavedJobs if you make any changes.
        var AccountDetails = (function () {
            function AccountDetails($, location, globalConfig, isJobsiteBrandConfig, siteConfig) {
                this.$ = $;
                this.location = location;
                this.globalConfig = globalConfig;
                this.isJobsiteBrandConfig = isJobsiteBrandConfig;
                this.siteConfig = siteConfig;
                this.signedInMessage = "{0}{1} account";
                this.signOutMessage = "Not {0}? Sign out";
                this.sessionStorageKey = "accountDetails";
                this.clearSessionCacheCookieName = "GetAccountDetailsCacheClear";
                this.isJobsiteBrand = false;
                this.context = null;
                this.sessionStorage = sessionStorage;
                if (this.$.isNullOrUndefined($)) {
                    throw new Error("'$' was not specified.");
                }
                if (this.$.isNullOrUndefined(location)) {
                    throw new Error("'location' was not specified.");
                }
                if (!this.$.isNullOrUndefined(isJobsiteBrandConfig)) {
                    this.isJobsiteBrand = isJobsiteBrandConfig;
                }
            }
            AccountDetails.reset = function () {
                AccountDetails.cachedAccountDetails = null;
                AccountDetails.callbackQueue = null;
                AccountDetails.cachedAuthDetails = null;
            };
            AccountDetails.prototype.setSessionStorage = function (sessionStorage) {
                this.sessionStorage = sessionStorage;
            };
            // This method is used by SavedJobs. You must test SavedJobs if you make any changes.
            AccountDetails.prototype.getAccountDetails = function (successCallback) {
                var _this = this;
                this.checkCacheControlCookieAndClearCacheIfPresent();
                if (successCallback == null) {
                    throw new Error("No callback was specified.");
                }
                // If we've already made a successful call, return immediately.
                if (AccountDetails.cachedAccountDetails != null) {
                    successCallback(AccountDetails.cachedAccountDetails);
                    return;
                }
                if (this.sessionStorage.getItem(this.sessionStorageKey) !== null) {
                    try {
                        var sessionCache = JSON.parse(this.sessionStorage.getItem(this.sessionStorageKey));
                        if (this.isActiveMemberId(sessionCache)) {
                            AccountDetails.cachedAccountDetails = sessionCache;
                            successCallback(sessionCache);
                            return;
                        }
                        this.sessionStorage.removeItem(this.sessionStorageKey);
                    }
                    catch (error) {
                        this.sessionStorage.removeItem(this.sessionStorageKey);
                    }
                }
                // If the call has not yet completed, add the callback to the queue.
                if (AccountDetails.callbackQueue != null) {
                    AccountDetails.callbackQueue.push(successCallback);
                    return;
                }
                var accountDetailsUrl = this.getAccountDetailsUrl();
                var $ = this.$;
                AccountDetails.callbackQueue = [successCallback];
                $.ajax({
                    url: accountDetailsUrl,
                    cache: false,
                    dataType: "json",
                    success: function (data) {
                        AccountDetails.cachedAccountDetails = data;
                        var sessionAccountDetails = data;
                        // Encoding Firstname in attempt to prevent stored XSS attack
                        var firstname = (sessionAccountDetails.Firstname != null) ? _this.htmlEntities(sessionAccountDetails.Firstname) : sessionAccountDetails.Firstname;
                        sessionAccountDetails.Firstname = firstname;
                        data.Firstname = sessionAccountDetails.Firstname;
                        sessionAccountDetails.ValidUntilDate = Date.now() + (30 * 60000);
                        _this.sessionStorage.setItem(_this.sessionStorageKey, JSON.stringify(sessionAccountDetails));
                        var callbacks = AccountDetails.callbackQueue;
                        AccountDetails.callbackQueue = null;
                        while (callbacks.length) {
                            var thisCallback = callbacks.pop();
                            thisCallback(data);
                        }
                        // trigger the event for others thats listening
                        $(window).trigger("GetAccountDetailsComplete");
                    },
                    error: function () {
                        var defaultState = {
                            LoggedInState: LoggedInState.NotLoggedIn,
                            Firstname: null,
                            MemberId: null,
                            JobsiteMemberId: null
                        };
                        var callbacks = AccountDetails.callbackQueue;
                        AccountDetails.callbackQueue = null;
                        while (callbacks.length) {
                            var thisCallback = callbacks.pop();
                            thisCallback(defaultState);
                        }
                    },
                    timeout: 30000
                });
            };
            AccountDetails.prototype.checkCacheControlCookieAndClearCacheIfPresent = function () {
                var _this = this;
                var clearCache = this.getCookieValue(this.clearSessionCacheCookieName);
                if (clearCache) {
                    var expiredDate = new Date();
                    expiredDate.setFullYear(expiredDate.getFullYear() - 1);
                    document.cookie = this.clearSessionCacheCookieName + "=; expires=" + expiredDate.toUTCString() + "; path=/;";
                    this.sessionStorage.removeItem(this.sessionStorageKey);
                    AccountDetails.cachedAccountDetails = null;
                    return;
                }
                if (AccountDetails.cachedAuthDetails != null) {
                    return;
                }
                $.ajax({
                    url: "/candidate-auth/whoami",
                    async: false,
                    cache: false,
                    success: function (data) {
                        AccountDetails.cachedAuthDetails = data;
                        if (_this.sessionStorage.getItem(_this.sessionStorageKey) !== null) {
                            try {
                                var sessionCache = JSON.parse(_this.sessionStorage.getItem(_this.sessionStorageKey));
                                if (sessionCache.LoggedInState !== data.result.loggedInState) {
                                    _this.sessionStorage.removeItem(_this.sessionStorageKey);
                                    AccountDetails.cachedAccountDetails = null;
                                    return;
                                }
                            }
                            catch (error) {
                                _this.sessionStorage.removeItem(_this.sessionStorageKey);
                                AccountDetails.cachedAccountDetails = null;
                            }
                        }
                    },
                    error: function () {
                        AccountDetails.cachedAuthDetails = {
                            result: null, errors: null, succeeded: null
                        };
                    },
                    timeout: 30000
                });
            };
            AccountDetails.prototype.isActiveMemberId = function (sessionCache) {
                return sessionCache.MemberId === this.getAnnoymousUserMemberId() && sessionCache.ValidUntilDate > Date.now();
            };
            AccountDetails.prototype.getAnnoymousUserMemberId = function () {
                return document.cookie.replace(/(?:(?:^|.*;\s*)AnonymousUser\s*\=\s*([^;]*).*$)|^.*$/, "$1")
                    .split(/[=|&]+/)[1];
            };
            AccountDetails.prototype.getCookieValue = function (cookieName) {
                var name = cookieName + "=";
                var allCookiesArray = document.cookie.split(";");
                for (var i = 0; i < allCookiesArray.length; i++) {
                    var temp = allCookiesArray[i].trim();
                    if (temp.indexOf(name) === 0) {
                        return temp.substring(name.length, temp.length);
                    }
                }
                return "";
            };
            AccountDetails.prototype.setSignOutMessage = function (navbarPersonalisation, firstname) {
                var $ = this.$;
                var message = "Sign out";
                if (!$.emptyString(firstname)) {
                    message = $.formatString(this.signOutMessage, firstname);
                }
                var signoutElement = navbarPersonalisation.find(".signout a");
                signoutElement.html(message);
            };
            AccountDetails.prototype.setAccountMessage = function (navbar, firstname) {
                var $ = this.$;
                var myAccountMessage;
                var targetElement = "span";
                if (!$.emptyString(firstname)) {
                    var firstNameEndsWithS = $.endsWith(firstname, "s");
                    var pluralChar = firstNameEndsWithS ? "&apos;" : "&apos;s";
                    myAccountMessage = $.formatString(this.signedInMessage, firstname, pluralChar);
                }
                else {
                    myAccountMessage = $.formatString(this.signedInMessage, "Your", "");
                }
                var personalisationToggle = navbar.find("#navbar-personalisation-toggle " + targetElement);
                personalisationToggle.html(myAccountMessage);
            };
            AccountDetails.prototype.initialize = function ($context, done) {
                var _this = this;
                this.context = $context;
                // Updates the header menu with the currently logged in user's name.
                // (The app doesn't do saved jobs, this is done via the /savedjobs/ javascript file)
                this.getAccountDetails(function (data) {
                    _this.accountDetailsSuccessCallback(_this, data);
                    done();
                });
            };
            AccountDetails.prototype.accountDetailsSuccessCallback = function (self, data) {
                var $ = this.$;
                var navbar = $("#navbar-header", self.context);
                var navbarPersonalisation = $("#navbar-personalisation-links", self.context);
                var anonymousClass = "anonymous";
                var loggedInClass = "logged-in";
                if (!$.isNullOrUndefined(data)) {
                    switch (data.LoggedInState) {
                        case LoggedInState.HardLogin:
                        case LoggedInState.SoftLogin:
                            {
                                self.setAccountMessage(navbar, data.Firstname);
                                self.setSignOutMessage(navbarPersonalisation, data.Firstname);
                                navbar.addClass(loggedInClass);
                                navbar.removeClass(anonymousClass);
                                break;
                            }
                        default:
                            // Anonymous login
                            navbar.removeClass(loggedInClass);
                            navbar.addClass(anonymousClass);
                            break;
                    }
                }
            };
            AccountDetails.prototype.getAccountDetailsUrl = function () {
                var accountDetailsUrl = this.globalConfig.AccountDetailsWebServiceUrl;
                var nullOrUndefined = this.$.isNullOrUndefined;
                if (!nullOrUndefined(this.siteConfig) && !nullOrUndefined(this.globalConfig.JobSeekerUrls)) {
                    var siteId = this.siteConfig.Site;
                    var siteUrl = !nullOrUndefined(siteId)
                        ? this.globalConfig.JobSeekerUrls[siteId]
                        : undefined;
                    accountDetailsUrl = !nullOrUndefined(siteUrl)
                        ? "https://" + siteUrl + accountDetailsUrl
                        : accountDetailsUrl;
                }
                return accountDetailsUrl;
            };
            AccountDetails.prototype.htmlEntities = function (str) {
                return String(str)
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;')
                    .replace(/'/g, '&#x27;')
                    .replace(/\\/g, '&#x5c;');
            };
            AccountDetails.cachedAccountDetails = null;
            AccountDetails.cachedAuthDetails = null;
            AccountDetails.callbackQueue = null;
            return AccountDetails;
        }());
        Header.AccountDetails = AccountDetails;
    })(Header = TotalJobsGroup.Header || (TotalJobsGroup.Header = {}));
})(TotalJobsGroup || (TotalJobsGroup = {}));

//# sourceMappingURL=account-details.js.map
